import React, { useCallback } from 'react';
import classNames from 'classnames';

import { BaseOptionId, SegmentedControlBaseOption, SegmentedControlState } from './types';

import { Button } from '../Button';

import styles from './SegmentedControl.module.scss';

export type SegmentedControlProps
<OptionId extends BaseOptionId = number, Option = SegmentedControlBaseOption<OptionId>> = {
  options: Option[];
  onSelect: (option: Option) => void;
  selectedId: OptionId;
  className?: string;
  optionClassName?: string;
  state?: SegmentedControlState;
};
//ToDo Добавить состояния PRIMARY и SECONDARY в storybook
export function SegmentedControl
<OptionId extends BaseOptionId, Option extends SegmentedControlBaseOption<OptionId>>({
  options,
  onSelect,
  selectedId,
  className,
  state = SegmentedControlState.PRIMARY,
  optionClassName,
}: SegmentedControlProps<OptionId, Option>) {
  const handleClick = useCallback((option: Option) => () => {
    onSelect(option);
  }, [onSelect]);

  const _className = classNames(styles.container, className);

  return (
    <div className={_className}>
      {options.map((option) => {
        const isSelected = selectedId === option.id;
        const isActivePrimary =  state === SegmentedControlState.PRIMARY;
        const isActiveSecondary =  state === SegmentedControlState.SECONDARY;

        const _optionClassName = classNames(styles.option, optionClassName, {
          [styles.activeOptionPrimary]: isSelected && isActivePrimary,
          [styles.activeOptionSecondary]: isSelected && isActiveSecondary,
          [styles.optionSecondary]: !isSelected && !isActivePrimary,
          [styles.optionPrimary]: !isSelected && !isActiveSecondary,
        });

        return (
          <Button
            key={option.id}
            className={_optionClassName}
            data-test={option.dataTest}
            data-ga-event={option.dataGaEvent}
            data-ga-event-value={option.dataGaEventValue}
            onClick={handleClick(option)}>
            {option.value}
          </Button>
        );
      })}
    </div>
  );
}
